export default __webpack_public_path__ + "static/media/header-site.10a89c2c.svg";